
import { defineComponent } from "vue";
import { mapState, mapMutations } from "vuex";

import ActionButton from "../Shared/ActionButton.vue";
import ProfileImage from "./ProfileImage.vue";
import SubNav from "./SubNav.vue";

import { LOGIN_USER } from "@/store/constants";

export default defineComponent({
  name: "MainNav",
  components: {
    ActionButton,
    ProfileImage,
    SubNav,
  },
  data() {
    return {
      menuItems: [
        { text: "Teams", url: "/teams" },
        { text: "Location", url: "/" },
        { text: "Benefits", url: "/" },
        { text: "Students", url: "/" },
        { text: "Jobs", url: "/jobs/results" },
      ],
    };
  },
  computed: {
    // to fix the MainNav & SubNav are hiding the Hero component
    headerHeightClass() {
      return this.$route.name === "JobResults" && this.isLoggedIn
        ? "h-32"
        : "h-16";
    },
    ...mapState(["isLoggedIn"]),
  },
  methods: {
    ...mapMutations([LOGIN_USER]),
  },
});
